module.exports = __webpack_public_path__ + "static/img/message-template-3.1770538668457.png";